import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "basic" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "example" }, null, -1)
const _hoisted_3 = { class: "outputs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("      "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-bash" }, "\n        npm install fp-money\n      "),
  /*#__PURE__*/_createTextVNode("\n    ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("      "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-html" }, "\n        <div id=\"example\"></div>\n      "),
  /*#__PURE__*/_createTextVNode("\n    ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("      "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n        import FPMoney from 'fp-money'\n        import 'fp-money/dist/fp-money.css'\n\n        new FPMoney({\n          container: document.querySelector('#example'),\n          // value: 86753.09,     // optional - default ''\n          // currencies: Object   // optional - {USD: {symbol: '$', fraction:2}}\n          // currency: 'USD',     // optional - default 'USD'\n          // locale: 'en-us',     // optional - default navigator.language\n          // minValue: 999,       // optional - default no limit\n          // maxValue: 999,       // optional - default no limit\n          // step: 1.00,          // optional - set up/down increment\n          // disabled: false,      // optional - default false\n          // displayOnly: false,      // optional - default false\n          // showSelection: false, // optional - default false\n\n          onChange: (values) => {\n            console.log(values)\n            // {\n            //   value: \"8675309\",\n            //   format: \"86753.09\",\n            //   display: \"$86,753.09\",\n            //   currency: \"USD\",\n            //   locale: \"en-US\"\n            // }\n          }\n        })\n      "),
  /*#__PURE__*/_createTextVNode("\n    ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" Value: " + _toDisplayString(_ctx.value), 1),
      _hoisted_4,
      _createTextVNode(" Format: " + _toDisplayString(_ctx.format), 1),
      _hoisted_5,
      _createTextVNode(" Display: " + _toDisplayString(_ctx.display), 1),
      _hoisted_6,
      _createTextVNode(" Currency: " + _toDisplayString(_ctx.currency), 1)
    ]),
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}